<template>

    <div class="post-wrapper conversation card card-shadow" :class="{'compact': displayMode === 'small', 'unread' : topic.unread, 'single-topic': singleTopic}">

        <topic-scroll-to-newest :singleTopic="singleTopic" :itemHighlighted="itemHighlighted" :topic="topic" :viewType="viewType"></topic-scroll-to-newest>

        <topic-helpdesk-status-switch :topic="topic"></topic-helpdesk-status-switch>

        <moodview-topic-top :topic="topic" :viewType="viewType"></moodview-topic-top>

        <!-- post top -->
        <!--<div class="post-top" v-if="topic.status == 'invisible' && topic.user().id == user.id">-->
        <div class="post-top">
            <img class="birthday-topic-balloon" src="/img/birthday-balloons.png">
            <div class="card-inner flex">
                <div class="flex-1 flex-no-padding">
                    <topic-user-icon :topic="topic"></topic-user-icon>
                </div>
                <div class="flex-16 flex-no-padding">
                    <div class="post-top-content">
                        <topic-top-meta :topic="topic" :viewType="viewType" :singleTopic="singleTopic"></topic-top-meta>
                    </div>
                </div>
            </div>
        </div>

        <!-- post likes & comments count -->
        <topic-stats class="relative" :topic="topic" :displayMode="displayMode"></topic-stats>

        <!-- post comments -->
        <comments :topic="topic" :viewType="viewType" :visibleComments="visibleComments" :focusCommentByHashId="focusCommentByHashId" :singleTopic="singleTopic"></comments>
    </div>
</template>

<script>
    //mixins
    import {mapState} from 'vuex';
    import Feed from '../../mixins/Feed.js'
    import Global from '../../mixins/Global.js'
    import Topic from '../../mixins/Topic.js'

    // Import de Like en Comment models. Handel daar de commit af naar de store -> dan action.
    export default {
        mixins: [Feed, Global, Topic],
    }
</script>

<style scoped>

</style>